import type { UserInputValidationError } from '@tectonics/prs/validation';

import { isDirectDebitSelected } from './direct-debit-required-field';

const MAX_LENGTH = 100;
const DIRECT_DEBIT_NAME_PATTERN = /^[\p{L}\p{M}\s]+$/u;

export function validateNigerianCustomerName(
  selectedPaymentMethod: string,
  selectedEwallet: string,
  customerNameValue: string,
  isReadonlyCustomerName: boolean
): UserInputValidationError | undefined {
  const customerName = customerNameValue || '';

  if (!customerName.trim()) {
    return { id: 'empty' };
  }

  if (customerName.length > MAX_LENGTH) {
    return { id: 'max-length' };
  }

  if (
    !isReadonlyCustomerName
    && isDirectDebitSelected(selectedPaymentMethod, selectedEwallet)
    && !DIRECT_DEBIT_NAME_PATTERN.test(customerName)
  ) {
    return { id: 'invalid-characters' };
  }

  return undefined;
}
